import React from 'react';

import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Row from 'react-bootstrap/Row';
import Spinner from "react-bootstrap/Spinner";

import Header from './Header';
import Footer from './Footer';

import TFM from '../cards/CardTFM';
import TFG from '../cards/CardTFG';
import PhDTheses from '../cards/CardPhD';




export default class Theses extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phdOngoing: [],
			phdFinished: [],
			tfmOngoing: [],
			tfmFinished: [],
			tfgOngoing: [],
			tfgFinished: [],
			master: [],
			degree: [],
			loadingThesisOng: true,
			loadingThesisFin: true,
			loadingTFMOng: true,
			loadingTFMFin: true,
			loadingTFGOng: true,
			loadingTFGFin: true,

		};
	}
	
	render() {
		return (
			<div className="about-page">
			<Header />
			<div className="content-theses">
				<Tabs defaultActiveKey="doctoral" id="tab-theses" className="mb-3" justify>
					<Tab eventKey="doctoral" title="PhD Theses">
					 	<Tabs defaultActiveKey="ongoing" id="tab-phd-theses" className="mb-3" justify>
							<Tab eventKey="ongoing" title="Ongoing">
								<Row xs={1} md={1} className="g-4">
									{this.state.loadingThesisOng ? <Spinner/> :<PhDTheses tesis={this.state.phdOngoing} id="tesisOngoing" item='5' />}
								</Row>
							</Tab>
							<Tab eventKey="finished" title="Finished">
								<Row xs={1} md={1} className="g-4">
									{this.state.loadingThesisFin ? <Spinner/> : <PhDTheses tesis={this.state.phdFinished} id="tesisFinished" item='5'/>}
								</Row>
							</Tab>
						</Tabs>
					</Tab>
					<Tab eventKey="master" title="Master Theses">
					<Tabs defaultActiveKey="ongoing" id="tab-master-theses" className="mb-3" justify>
						<Tab eventKey="ongoing" title="Ongoing">
								<Row xs={1} md={1} className="g-4">
									{this.state.loadingTFMOng ? <Spinner/> : <TFM tfm={this.state.tfmOngoing} id="tfmOngoing" item='5' />}

								</Row>
							</Tab>
							<Tab eventKey="finished" title="Finished">
								<Row xs={1} md={1} className="g-4">
									{this.state.loadingTFMFin ? <Spinner/> : <TFM tfm={this.state.tfmFinished} id="tfmFinished" item='5' />	}
								</Row>
							</Tab>
							</Tabs>
					</Tab>
					<Tab eventKey="degree" title="Undergraduate Final Works">
					<Tabs defaultActiveKey="ongoing" id="tab-undergraduate" className="mb-3" justify>
						<Tab eventKey="ongoing" title="Ongoing">
								<Row xs={1} md={1} className="g-4">
									{this.state.loadingTFGOng ? <Spinner/> : <TFG tfg={this.state.tfgOngoing} id="tfgOngoing" item='5' />	}
								</Row>
							</Tab>
							<Tab eventKey="finished" title="Finished">
								<Row xs={1} md={1} className="g-4">
									{this.state.loadingTFGFin ? <Spinner/> : <TFG tfg={this.state.tfgFinished} id="tfgFinished" item='5'/>	}
								</Row>
							</Tab>
							</Tabs>
					</Tab>
				</Tabs>			
			</div>
			<Footer />
			</div>
		)
	}
	
	componentDidMount(){
		window.scrollTo(0,0);
		fetch(process.env.PUBLIC_URL+"/assets/json/phd_theses-ongoing.json").then(res=>res.json()).then(phdOngoing=>this.setState({phdOngoing, loadingThesisOng: false}));
		fetch(process.env.PUBLIC_URL+"/assets/json/phd_theses-finished.json").then(res=>res.json()).then(phdFinished=>this.setState({phdFinished, loadingThesisFin: false}));
		fetch(process.env.PUBLIC_URL+"/assets/json/tfm-ongoing.json").then(res=>res.json()).then(tfmOngoing=>this.setState({tfmOngoing, loadingTFMOng: false}));
		fetch(process.env.PUBLIC_URL+"/assets/json/tfm-finished.json").then(res=>res.json()).then(tfmFinished=>this.setState({tfmFinished, loadingTFMFin: false}));
		fetch(process.env.PUBLIC_URL+"/assets/json/tfg-ongoing.json").then(res=>res.json()).then(tfgOngoing=>this.setState({tfgOngoing, loadingTFGOng: false}));
		fetch(process.env.PUBLIC_URL+"/assets/json/tfg-finished.json").then(res=>res.json()).then(tfgFinished=>this.setState({tfgFinished, loadingTFGFin: false}));
	}
}